import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, FlagIcon, BookOpenIcon, ActivityIcon, CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const features = [{
    icon: <FileTextIcon className="w-3 h-3" data-id="element-120" />,
    text: '100% PDF'
  }, {
    icon: <ZapIcon className="w-3 h-3" data-id="element-121" />,
    text: 'Acceso en 5 min'
  }, {
    icon: <FlagIcon className="w-3 h-3" data-id="element-122" />,
    text: 'Hecho para Argentina'
  }, {
    icon: <BookOpenIcon className="w-3 h-3" data-id="element-123" />,
    text: '6 Tomos completos'
  }, {
    icon: <ActivityIcon className="w-3 h-3" data-id="element-124" />,
    text: 'Masa → Negocio en pesos'
  }, {
    icon: <CheckCircleIcon className="w-3 h-3" data-id="element-125" />,
    text: '4 Bonos incluidos'
  }];
  const stats = ['+500 emprendedoras confían', '6 Tomos listos', '4 Bonos incluidos', '4,9/5 ⭐'];
  return <section className="w-full bg-[#FBF5EC] donut-pattern py-4 md:py-10" data-id="element-126">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-128">
          <div className="mb-3 md:mb-4" data-id="element-129">
            <span className="inline-block bg-[#FDE4CE] text-[#B45309] font-bold tracking-wider px-3 py-1 rounded-full text-[10px] pt-[1px] pb-[1px]" data-id="element-130">
              🍩 RECURSOHUB™
            </span>
          </div>

          <h1 className="md:text-6xl lg:text-7xl text-[#3D2817] mb-0.5 md:mb-1 text-[25px] font-[600] leading-[1.05]" data-id="element-131">
            Aprendé a vender minidonas desde casa y convertí cumpleaños, eventos
            y reuniones en una fuente real de ingresos.
          </h1>

          <h2 className="md:text-5xl lg:text-6xl text-[#7A4A2B] mb-2 md:mb-3 text-[14px] font-[600] font-[Avenir,_sans-serif] leading-[1.1]" data-id="element-132">
            Sistema paso a paso con recetas, costos, precios de venta, packaging
            y estrategias para empezar incluso sin experiencia.
          </h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.7
        }} className="mb-3 md:mb-5" data-id="element-133">
            <img src="https://cdn.magicpatterns.com/uploads/h4Hh8CWUHpwi1R1gzN3Jrb/ChatGPT_Image_21_may_2026,_02_04_30_p.m..png" alt="Mega Pack Emprende Minidonas 360 — 6 Tomos + 4 Bonos" className="max-w-md md:max-w-lg lg:max-w-2xl mx-auto w-full h-auto" data-id="element-134" />
          </motion.div>

          <div className="mb-1 md:mb-3" data-id="element-135"></div>

          <p className="md:text-lg text-[#6B5747] mb-3 md:mb-5 max-w-3xl mx-auto text-[14px]" data-id="element-136"></p>

          <div className="flex flex-wrap justify-center gap-1.5 mb-3 md:mb-5" data-id="element-137">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: index * 0.1,
            duration: 0.3
          }} className="flex items-center gap-1 bg-white border border-[#E8D5BA] rounded-full px-2.5 py-1 shadow-sm" data-id="element-138">
                <span className="text-[#B45309]" data-id="element-139">{feature.icon}</span>
                <span className="text-xs text-[#6B5747] font-medium" data-id="element-140">
                  {feature.text}
                </span>
              </motion.div>)}
          </div>

          <motion.a href="#boton-pago" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-[#B45309] hover:bg-[#92400E] text-white font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-lg mb-2 md:mb-3 transition-colors shadow-lg shadow-[#7A4A2B]/30 cursor-pointer" data-id="element-141">
            🔴 QUIERO VENDER MIS PRIMERAS MINIDONAS!
          </motion.a>

          <p className="text-sm text-[#9B8770] mb-3 md:mb-6" data-id="element-142">
            📩Acceso inmediato por Mail | 🎁50% OFF Solo por Hoy
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 max-w-3xl mx-auto" data-id="element-143">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8 + index * 0.1,
            duration: 0.4
          }} className={`${index % 2 === 0 ? 'bg-white' : 'bg-[#FDF1E4]'} border border-[#E8D5BA] rounded-lg p-2 md:p-3 shadow-sm`} data-id="element-144">
                <p className="text-sm md:text-base font-semibold text-[#3D2817]" data-id="element-145">
                  {stat}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}